import styled from 'styled-components';
import { Grid } from '../leave-dashboard/styles';

// Ekibimin İzinleri — İzin Paneli'nin kart dili (leave-dashboard/styles) + TEK KAYDIRMA sözleşmesi: sayfa kaymaz,
// her kartın liste alanı (ScrollArea) tek kaydırma noktasıdır. Dar ekranda kartlar alt alta dizilir ve Layout'un
// <main>'i kayar; o zaman kart içi kaydırma kapanır (iç içe scroll yasağı).
const NARROW = '768px';

export const Root = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: ${NARROW}) {
    height: auto;
  }
`;

export const TeamGrid = styled(Grid)`
  flex: 1;
  min-height: 0;
  align-items: stretch;

  @media (max-width: ${NARROW}) {
    flex: none;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  @media (max-width: ${NARROW}) {
    overflow: visible;
  }
`;

export const PendingChip = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 10px;
  white-space: nowrap;
  background: #FFFFFF;
  color: #B45309;
  border: 1px dashed #D97706;
`;

export const Tag = styled.span`
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  border-radius: 6px;
  padding: 0 4px;
  color: ${({ $self }) => ($self ? '#1D4ED8' : '#6B7280')};
  background: ${({ $self }) => ($self ? '#DBEAFE' : '#F3F4F6')};
`;

export const MonthNav = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 190px;
`;

export const NavBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  background: #FFFFFF;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;

  &:disabled { opacity: 0.4; cursor: default; }
`;

export const BandHeader = styled.div`
  display: flex;
  margin-left: 130px;
  border-bottom: 1px solid #F0F2F5;
  padding-bottom: 4px;
`;

export const BandLabel = styled.div`
  flex: ${({ $days }) => $days};
  font-size: 10px;
  font-weight: 700;
  color: #9CA3AF;
  text-align: center;
`;

export const TimelineRow = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
`;

export const RowLabel = styled.div`
  width: 130px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};

  > span.name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Track = styled.div`
  position: relative;
  flex: 1;
  height: 22px;
  border-radius: 4px;
  background: #F7F9FB;
  box-shadow: ${({ $self }) => ($self ? 'inset 0 0 0 1px #93C5FD' : 'none')};
`;

export const BandLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ $left }) => $left}%;
  width: 1px;
  background: #EDF0F4;
`;

export const TodayLine = styled.div`
  position: absolute;
  top: -4px;
  bottom: -4px;
  left: ${({ $left }) => $left}%;
  width: 2px;
  border-radius: 1px;
  background: #EF4444;
  z-index: 1;
`;

export const PENDING_FILL = 'repeating-linear-gradient(45deg, #FDE7C2 0 4px, #FFF6E6 4px 8px)';

export const Bar = styled.div`
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: ${({ $left }) => $left}%;
  width: ${({ $width }) => $width}%;
  min-width: 6px;
  border-radius: 4px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  ${({ $pending, $color }) => ($pending
    ? `background: ${PENDING_FILL}; border: 1px dashed #D97706; color: #B45309; line-height: 16px;`
    : `background: ${$color}; color: #FFFFFF; line-height: 18px;`)}
`;

export const MoreWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;
